/**
 * !nordy - Discord OAuth 콜백 팝업 핸들러
 *
 * 업스트림 라우터의 getBasePath()가 window.location.pathname을 basePath로 사용하므로,
 * /discord 경로에서 열린 팝업은 basePath="/discord"가 되어 라우트 매칭이 실패한다.
 * 이 모듈은 main.ts보다 먼저 실행되어, 팝업이면 code를 부모 창에 전달하고 즉시 닫는다.
 */

if (
  window.opener &&
  !window.opener.closed &&
  window.location.pathname.endsWith('/discord')
) {
  const params = new URLSearchParams(window.location.search)
  const code = params.get('code')
  const error = params.get('error')
  const origin = window.location.origin

  if (code) {
    window.opener.postMessage(
      { type: 'discordLogin', provider: 'discord', code },
      origin
    )
  } else if (error) {
    window.opener.postMessage(
      { type: 'discordLoginError', provider: 'discord', error },
      origin
    )
  }

  //! nordy - innerHTML 대신 textContent 사용하여 XSS 방지
  const el = document.getElementById('vue-app')
  if (el) {
    el.textContent = 'Processing...'
    Object.assign(el.style, {
      textAlign: 'center',
      padding: '2rem',
      color: '#999'
    })
  }

  setTimeout(() => window.close(), 500)
}
